<template>
  <div class="demo">
    <div class="hero">
      <div class="container">
        <h3>Reprehendo BV</h3>
        <h1>Algemene Voorwaarden</h1>

        <p>
          <strong>Artikel 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Algemeen</strong>
        </p>

        <p>
          1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Deze Algemene
          Voorwaarden zijn van toepassing op de totstandkoming, uitleg en
          uitvoering van alle door Reprehendo B.V.
          (hierna:&nbsp;<strong>Reprehendo</strong>) te sluiten overeenkomst(en)
          (hierna: de&nbsp;<strong>Overeenkomst</strong>) met derden
          (hierna:&nbsp;<strong>Opdrachtgever</strong>) inzake alle door
          Reprehendo te leveren diensten en faciliteiten op het gebied van onder
          meer, doch niet uitsluitend, software (advisering, ontwikkeling,
          levering, installatie etc.), data hosting, alsmede algemene diensten
          (advisering over, onderhoud van, alsmede installatie van apparatuur en
          diverse netwerk componenten, telefonische helpdesk etc.) (hierna:
          de&nbsp;<strong>Diensten</strong>).
        </p>

        <p>
          1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De Algemene
          Voorwaarden van Opdrachtgever of andere derden, worden door Reprehendo
          niet aanvaard en zullen geen deel uitmaken van een door Reprehendo met
          Opdrachtgever gesloten Overeenkomst, behoudens uitdrukkelijke
          schriftelijke acceptatie door Reprehendo. Opdrachtgever wordt geacht
          met de uitsluitende toepasselijkheid van deze Algemene Voorwaarden te
          hebben ingestemd.
        </p>

        <p>
          1.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Op alle
          Overeenkomsten, aanbiedingen, offertes en/of inschrijvingen van
          Reprehendo (al dan niet tezamen met derden) zijn, voor zover niet
          schriftelijk anders is overeengekomen, uitsluitend van toepassing deze
          Algemene Voorwaarden, alsmede de bepalingen en/of inhoud van de door
          Reprehendo aan Opdrachtgever verstrekte opdrachtbevestiging, inclusief
          bijlage(n).
        </p>

        <p>
          <strong>Artikel 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Totstandkoming Overeenkomst</strong>
        </p>

        <p>
          2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Overeenkomsten
          tussen Reprehendo en Opdrachtgever komen tot stand door en op het
          moment van schriftelijke acceptatie door Reprehendo van een ingediende
          aanvraag of order van Opdrachtgever.
        </p>

        <p>
          2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De Diensten worden
          ingepland en uitgevoerd door Reprehendo nadat de rechtsgeldig
          getekende Overeenkomst door Reprehendo is ontvangen.&nbsp;Indien en
          voor zover de Diensten van Reprehendo door Opdrachtgever worden
          afgenomen zonder dat deze schriftelijk zijn overeengekomen is sprake
          van een de facto Overeenkomst en zijn alle bepalingen uit deze
          Algemene Voorwaarden van toepassing.
        </p>

        <p>
          <strong>Artikel 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Duur en beëindiging Overeenkomst</strong>
        </p>

        <p>
          3.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo voert
          de Overeenkomst uit binnen de schriftelijk bij Overeenkomst
          overeengekomen tijd, dan wel binnen de tijd die voortvloeit uit de
          aard van de te verrichten Diensten. De door Reprehendo verrichtte
          Diensten staan ter beschikking van de Opdrachtgever na oplevering door
          Reprehendo, tenzij partijen schriftelijk anders zijn overeengekomen in
          de Overeenkomst.
        </p>

        <p>
          3.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo is
          gerechtigd de Overeenkomst schriftelijk op te zeggen, zulks met
          inachtneming van een opzegtermijn van een maand. Indien en voor zover
          er sprake is van gewichtige redenen of omstandigheden die voltooiing
          of voortzetting van de Overeenkomst door Reprehendo in redelijkheid
          niet mogelijk maken, kan Reprehendo de Overeenkomst echter terstond
          opzeggen, zonder inachtneming van een opzegtermijn. Voor beëindiging
          van de Overeenkomst op grond van gewichtige redenen aanvaardt
          Reprehendo geen aansprakelijkheid jegens Opdrachtgever.
        </p>

        <p>
          3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Van gewichtige
          redenen kan onder meer, doch niet uitsluitend, sprake zijn
          indien&nbsp;de Opdrachtgever failliet is verklaard of een daartoe
          strekkend verzoek is ingediend bij de bevoegde rechtbank, indien een
          verzoek tot surseance van betaling is ingediend of een dergelijk
          verzoek is gehonoreerd, danwel Opdrachtgever de bedrijfsuitvoering
          heeft gestaakt.
        </p>

        <p>
          3.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Opdrachtgever is
          gerechtigd de Overeenkomst schriftelijk op te zeggen zonder
          inachtneming van een opzegtermijn. Zodanige vroegtijdige opzegging
          laat onverlet het recht van Reprehendo tot uitbetaling door
          Opdrachtgever van de overeengekomen vergoeding betrekking hebbende op
          de reeds verrichte werkzaamheden, alsmede het recht van Reprehendo op
          eventuele schadevergoeding.&nbsp;Onder deze schade wordt onder meer,
          doch niet uitsluitend, begrepen de kosten die Reprehendo ter
          voorbereiding van de werkzaamheden heeft gemaakt zoals onder meer,
          doch niet uitsluitend, de gemaakte kosten van reeds geleverde of
          uitgevoerde Diensten, gereserveerde productiecapaciteit, ingekochte
          materialen, danwel ingeroepen diensten van derden.<br>
        </p>

        <p>
          <strong>Artikel 4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Betalingen</strong>
        </p>

        <p>
          4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De door Reprehendo
          te verrichte diensten zullen op basis van de in de Overeenkomst
          opgenomen tarieven en prijzen worden gefactureerd aan Opdrachtgever.
          Alle door Reprehendo aan Opdrachtgever door te berekenen tarieven en
          prijzen zijn exclusief BTW.
        </p>

        <p>
          4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alle betalingen
          door Opdrachtgever dienen te geschieden op een door Reprehendo aan te
          wijzen bankrekening, onder vermelding van (het kenmerk van) de
          werkzaamheden of opdracht. Alle Diensten worden in beginsel
          maandelijks in rekening gebracht bij Opdrachtgever, tenzij Reprehendo
          en Opdrachtgever anders zijn overeengekomen. Reprehendo is steeds
          gerechtigd een voorschotdeclaratie in rekening brengen, alvorens met
          de werkzaamheden wordt aangevangen.
        </p>

        <p>
          4.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alle betalingen
          aan Reprehendo dienen plaats te vinden door Opdrachtgever binnen 14
          dagen na factuurdatum, ongeacht of Opdrachtgever de verrichte Diensten
          en/of aangeboden faciliteiten benut, tenzij Reprehendo en
          Opdrachtgever uitdrukkelijk schriftelijk anders zijn overeengekomen.
          De in dit lid genoemde termijn geldt als fatale termijn. Verstrekt
          Opdrachtgever een machtiging tot automatische incasso dan draagt
          Opdrachtgever zorg voor voldoende saldo en voor een toestemming tot
          afschrijving bij de bank- of giro instelling. Blijkt een bedrag niet
          incasseerbaar door Reprehendo, dan zal Opdrachtgever alsnog zorg
          dragen voor betaling binnen 14 dagen na factuurdatum.
        </p>

        <p>
          4.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Met
          betrekking tot extra kosten of uren die Reprehendo heeft moeten maken,
          daarin begrepen het uitvoeren van aanvullende diensten, geldt dat,
          indien veroorzaakt door Opdrachtgever, Reprehendo gerechtigd is deze
          apart bij Opdrachtgever in rekening te brengen.&nbsp;Opdrachtgever
          aanvaardt dat door het verrichten van aanvullende Diensten door
          Reprehendo het overeengekomen of verwachte tijdstip van voltooiing van
          de Diensten kan worden beïnvloed.
        </p>

        <p>
          4.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indien door
          Opdrachtgever een of meer betalingen niet binnen de overeengekomen
          termijn is/zijn verricht, is Opdrachtgever in verzuim zonder dat een
          daartoe strekkende mededeling vereist is. De Opdrachtgever is alsdan
          gehouden, naast de verschuldigde hoofdsom, tot vergoeding van 1,5%
          vertragingsrente per maand over het bedrag van de openstaande
          declaratie inclusief wettelijke rente,&nbsp;waarbij een gedeelte van
          een maand als volledige maand wordt gerekend.
        </p>

        <p>
          <strong>Artikel 5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Tekortkomingen Opdrachtgever</strong>
        </p>

        <p>
          5.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Is de
          Opdrachtgever in verzuim of schiet hij op een andere wijze tekort in
          de nakoming van een of meer van zijn verplichtingen uit hoofde van de
          Overeenkomst, dan is Reprehendo gerechtigd de Diensten voor
          Opdrachtgever met onmiddellijke ingang en voor onbepaalde tijd op te
          schorten, alsmede de door haar en of door haar ingeschakelde derden
          eventueel vervaardigde software en/of materiaal en/of producten en/of
          faciliteiten onder zich te houden, een en ander tot het tijdstip
          waarop Opdrachtgever de vordering(en) van Reprehendo heeft
          voldaan.&nbsp;In het bijzonder is Reprehendo gerechtigd de betrokken
          website en domeinnamen (al dan niet tijdelijk of permanent) op te
          heffen.
        </p>

        <p>
          5.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; In het geval
          bedoeld in het vorige lid, komen alle redelijke kosten, zowel de
          gerechtelijke als de buitengerechtelijke, alsmede de schade van
          Reprehendo en de door haar ingeschakelde derden als gevolg van verzuim
          of andere tekortkoming van de Opdrachtgever, voor rekening van
          Opdrachtgever. Het bedrag van de buitengerechtelijke kosten wordt
          daarbij gesteld op 15% van het bedrag van de totale contractuele
          schuld aan Reprehendo, met een minimum van EUR 500,– (zegge:
          vijfhonderd Euro), of zoveel meer als de werkelijke
          buitengerechtelijke kosten bedragen.
        </p>

        <p>
          <strong>Artikel 6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Verplichtingen Opdrachtgever</strong>
        </p>

        <p>Algemene verplichtingen</p>

        <p>
          6.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Opdrachtgever zal
          Reprehendo steeds tijdig alle voor een behoorlijke uitvoering van de
          Overeenkomst nuttige en noodzakelijke gegevens of inlichtingen
          verschaffen en Reprehendo alle medewerking verlenen.
        </p>

        <p>
          6.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indien is
          overeengekomen dat Opdrachtgever programmatuur, materialen of gegevens
          op informatiedragers ter beschikking zal stellen, zullen deze voldoen
          aan de voor het uitvoeren van de werkzaamheden noodzakelijke
          specificaties.
        </p>

        <p>
          6.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo heeft,
          indien de voor de uitvoering van Overeenkomst noodzakelijke gegevens
          door Opdrachtgever niet, niet tijdig of niet overeenkomstig de
          gemaakte schriftelijke afspraken ter beschikking&nbsp; staan of worden
          gesteld aan Reprehendo, het recht tot opschorting van de uitvoering
          van de Overeenkomst, alsmede het recht om de daardoor ontstane kosten
          volgens gebruikelijke tarieven in rekening te brengen.
        </p>

        <p>
          6.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indien
          Opdrachtgever schade veroorzaakt aan Reprehendo of derden, al dan niet
          door overtreding van de bepalingen uit deze Algemene Voorwaarden of de
          Overeenkomst, is Opdrachtgever gehouden deze schade te
          vergoeden.&nbsp;Opdrachtgever vrijwaart Reprehendo tegen aanspraken
          van en schade aan derden die op enigerlei wijze mocht ontstaan, al dan
          niet door het gebruik door Opdrachtgever van de Diensten van
          Reprehendo.
        </p>

        <p>
          6.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Opdrachtgever
          dient Reprehendo binnen 24 uur na constatering van een mogelijk
          disfunctioneren, dan wel storing of vermeende aansprakelijkheden van
          Reprehendo schriftelijk in te lichten en Opdrachtgever zal Reprehendo
          een redelijke termijn geven voor herstel; indien voornoemde inlichting
          niet tijdig plaats vindt verliest Opdrachtgever ieder recht op enige
          vordering. Indien schade zou zijn ontstaan verwijtbaar aan Reprehendo
          kan de vergoeding nooit meer bedragen dan het voor de betreffende
          Opdrachtgever gefactureerde bedrag per jaar.
        </p>

        <p>
          6.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ingeval
          medewerkers van Reprehendo op de locatie van Opdrachtgever
          werkzaamheden dienen te verrichten, dient Opdrachtgever kosteloos zorg
          te dragen voor de door die medewerkers in redelijkheid gewenste
          faciliteiten zoals onder meer, doch niet uitsluitend, een werkruimte
          met telecommunicatiefaciliteiten etc. Opdrachtgever zal Reprehendo
          vrijwaren voor aanspraken van derden, medewerkers van Reprehendo
          daaronder begrepen, die in verband met de uitvoering van de
          Overeenkomst schade lijden als gevolg van een handelen of nalaten van
          Opdrachtgever, dan wel als gevolg van onveilige situaties in de
          organisatie van Opdrachtgever.
        </p>

        <p>
          6.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Opdrachtgever zal
          de van Reprehendo verkregen informatie, inlogspecificaties, user ids,
          alsmede password(s) niet ter beschikking stellen aan derden welke
          soortgelijke diensten aanbieden als Reprehendo, noch aan de daarmee
          gerelateerde rechtspersonen of natuurlijke personen.
        </p>

        <p>
          6.8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Opdrachtgever zal
          de door Reprehendo ter beschikking gestelde faciliteiten niet
          gebruiken voor handelingen en/of gedragingen die in strijd zijn met de
          wet, de goede zeden, de openbare orde, de Overeenkomst en deze
          Algemene Voorwaarden. Hieronder vallen onder meer, doch niet
          uitsluitend, de volgende handelingen en gedragingen: het verspreiden
          van kinderpornografie, seksuele intimidatie, spamming, het inbreuk
          plegen op auteursrechtelijk beschermde werk(en) of het anderszins
          handelen in strijd met de intellectuele eigendomsrechten van derden,
          of het op andere wijze lastig vallen van personen, het zonder
          toestemming binnendringen van andere computers op het Internet waarbij
          de Opdrachtgever enige beveiliging doorbreekt en/of zich toegang
          verwerft door een technische ingreep met behulp van valse signalen of
          een valse sleutel dan wel door het aannemen van een valse
          hoedanigheid.
        </p>

        <p>
          Bijzondere verplichtingen van Opdrachtgever ten aanzien van Hosting
        </p>

        <p>
          6.9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Niettegenstaande
          het bepaalde in artikel 6.4, zal Opdrachtgever haar webhosting
          faciliteiten niet gebruiken of verhuren voor teksten, plaatjes
          (images), aanprijzingen, reclame of overige publiciteit die betrekking
          hebben op pornografisch materiaal, Warez sites, illegale software
          sites, mp3 sites, chat-sites, webcam-sites e.d.
        </p>

        <p>
          6.10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bij verhuizing van internetdomeinen
          naar Reprehendo is Opdrachtgever verantwoordelijk voor het tijdig
          opzeggen van de Overeenkomst met de betrokken provider en het
          verkrijgen van diens eventuele fiattering. Opdrachtgever blijft echter
          gehouden tot betaling van de door Reprehendo reeds geleverde Diensten
          ongeacht (het moment van) de verkrijging van de medewerking van de
          (vorige) provider van Opdrachtgever.
        </p>

        <p>
          6.11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indien Opdrachtgever haar domeinen
          verhuist of doet verhuizen van Reprehendo naar een andere provider
          blijven de bepalingen van de Overeenkomst en deze Algemene Voorwaarden
          onverkort van kracht totdat Opdrachtgever volgens de bepalingen van
          artikel 3 heeft opgezegd. Reprehendo is gerechtigd de medewerking voor
          verhuizing van de domeinen naar een andere provider te weigeren indien
          er sprake is van onregelmatige opzegging door Opdrachtgever. De
          rechten van onbetaalde domeinen behoren aan Reprehendo toe en alle
          schade en kosten voortvloeiend uit beslaglegging en andere maatregelen
          terzake de inning hiervan komen geheel voor rekening van
          Opdrachtgever.&nbsp;
        </p>

        <p>
          6.12&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De Opdrachtgever zal nimmer de
          systemen en instellingen van Reprehendo of anderen beschadigen of de
          Diensten &nbsp;gebruiken voor&nbsp;hacking, sniffing, DOS attacks,
          TReprehendo/SYN, SPOOF, dan wel soortgelijke activiteiten. Voorts zal
          Opdrachtgever de door Reprehendo ter beschikking gestelde faciliteit
          niet (laten) ontdoen van of (laten) verruimen met de
          beveiligingsinstellingen (security) jegens derden.
        </p>

        <p>
          6.13&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De Opdrachtgever zal geen
          ongevraagde e-mail (spam) versturen en zal tevens niemand daartoe
          opdracht geven. De Opdrachtgever zal geen opdrachten verstrekken aan
          derden welke mailings in nieuwsgroepen uitvoeren (gelijk aan spam) of
          zich anderszins bezighouden met het versturen van e-mails in groten
          getale. Overtreding van dit artikel wordt beschouwd als een gewichtige
          reden in de zin van artikel 3.2.
        </p>

        <p>
          6.14&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ingeval van inbreuk door
          Opdrachtgever op een of meer bepalingen van dit artikel&nbsp;<br>
          zal Opdrachtgever ten behoeve van Reprehendo een direct opeisbare
          boete verbeuren van EUR&nbsp;<em>15.000,–</em>,(zegge
          vijftienduizend)&nbsp;&nbsp;alsmede een boete van
          EUR&nbsp;<em>1.000,–</em>&nbsp;(zegge duizend) per dag dat de inbreuk
          voortduurt, een en ander ongeacht de bevoegdheid van Reprehendo om de
          daadwerkelijk geleden schade op Opdrachtgever te verhalen.<br>
        </p>

        <p>
          <strong>Artikel 7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Aansprakelijkheid</strong>
        </p>

        <p>
          7.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo staat
          op geen enkele manier in voor aansprakelijkheden die Opdrachtgever op
          zich neemt ten opzichte van derden, dan wel die anderszins voor
          Opdrachtgever in verband met de Overeenkomst met Reprehendo (of de
          uitvoering daarvan) ontstaan.
        </p>

        <p>
          7.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo is niet
          aansprakelijk voor schade aan informatiedragers van Opdrachtgever (of
          van derden) die door apparatuur of programmatuur van Reprehendo wordt
          veroorzaakt, noch voor schade of kosten die daaruit voortvloeien.
        </p>

        <p>
          7.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo is
          slechts aansprakelijk voor schade ontstaan ten gevolge van gebreken in
          de door Reprehendo geleverde Diensten dan wel schade toegebracht aan
          eigendommen van de Opdrachtgever, indien en&nbsp;voor zover die schade
          is veroorzaakt door opzet of bewuste roekeloosheid van Reprehendo.
        </p>

        <p>
          7.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tekortkomingen
          van Reprehendo in de nakoming van de Overeenkomst met de Opdrachtgever
          kunnen slechts aan Reprehendo worden toegerekend, indien zij te wijten
          zijn aan haar schuld, of indien zij krachtens de wet, de Overeenkomst
          of de in het verkeer geldende opvattingen voor haar rekening dienen te
          komen.
        </p>

        <p>
          7.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo is niet
          verantwoordelijk voor de tools, applicaties en software van derden,
          noch op diens servers, noch op de lokale apparatuur waarmee
          Opdrachtgever werkt, tenzij schriftelijk anders tussen Opdrachtgever
          en Reprehendo is overeengekomen.
        </p>

        <p>
          7.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Opdrachtgever
          vrijwaart Reprehendo voor aanspraken van derden op Reprehendo terzake
          van de door Reprehendo voor Opdrachtgever verrichtte Diensten.
        </p>

        <p>
          7.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; De in de
          voorgaande artikelen vervatte regeling van aansprakelijkheid en
          vrijwaring geldt mede ten behoeve van de ondergeschikten van
          Reprehendo en van diegenen, die door Reprehendo voor de uitvoering van
          de Overeenkomst zijn ingeschakeld.
        </p>

        <p>
          <strong>Artikel 8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Intellectuele en industriële eigendomsrechten</strong>
        </p>

        <p>
          8.1&nbsp;&nbsp;&nbsp;&nbsp; Reprehendo is niet aansprakelijk voor
          enige inbreuk op rechten van intellectuele of industriële eigendom van
          derden. Opdrachtgever vrijwaart Reprehendo voor alle aanspraken van
          derden tot schadevergoeding als gevolg van enige inbreuk op rechten
          van intellectuele of industriële eigendom. Deze expliciete vrijwaring
          geldt voor onbepaalde tijd vanaf het moment dat de Overeenkomst tussen
          Reprehendo en Opdrachtgever tot stand is gekomen.
        </p>

        <p>
          8.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Op Reprehendo rust
          op geen enkel moment enige verplichting zich te vergewissen van de
          rechtmatige intellectuele en/of industriële eigendomsrechten van
          Opdrachtgever ten aanzien van het geleverde materiaal en/of Diensten
          uit hoofde van de Overeenkomst.
        </p>

        <p>
          8.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Alle rechten
          van intellectuele of industriële Eigendom van Reprehendo die
          voortvloeien of ontstaan uit diensten die Reprehendo voor
          Opdrachtgever verricht berusten uitsluitend bij Reprehendo, diens
          licentiegevers of diens toeleveranciers. Het&nbsp;is Opdrachtgever
          verboden door Reprehendo vervaardigde of verstrekte zaken, waaronder,
          maar niet beperkt tot, databestanden, offertes, concepten,
          strategieën, modellen, documentatie, software of andere materialen te
          kopiëren, aan derden ter inzage te geven/in gebruik te geven/over te
          dragen/in licentie te geven, zonder uitdrukkelijke voorafgaande
          schriftelijke toestemming van Reprehendo.
        </p>

        <p>
          8.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Indien
          in afwijking van artikel&nbsp;&nbsp;8.4&nbsp;&nbsp;Reprehendo bereid
          is zich te verbinden tot overdracht van een recht van intellectuele of
          industriële eigendom, kan een zodanige verbintenis steeds slechts
          schriftelijk en uitdrukkelijk worden aangegaan. Indien partijen
          schriftelijk en uitdrukkelijk overeenkomen dat rechten van
          intellectuele of industriële eigendom ten aanzien van specifiek voor
          Opdrachtgever ontwikkelde&nbsp;databestanden, offertes, concepten,
          strategieën, modellen, documentatie, software of andere materialen,
          over zullen gaan op Opdrachtgever, dan laat dit de bevoegdheid van
          Reprehendo onverlet om de aan die ontwikkeling ten grondslag liggende
          onderdelen, algemene beginselen, ideeën, ontwerpen, documentatie,
          werken en dergelijke, zonder enige beperking voor andere doeleinden
          toe te passen en te exploiteren, hetzij voor zich zelf hetzij voor
          derden. Evenmin tast een overdracht van rechten van intellectuele of
          industriële eigendom het recht van Reprehendo aan om ten behoeve van
          zichzelf of derden ontwikkelingen te ondernemen die soortgelijk zijn
          aan die welke ten behoeve van Opdrachtgever zijn of worden gedaan.<br>
        </p>

        <p>
          <strong>Artikel 9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Overmacht</strong>
        </p>

        <p>
          9.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Indien Reprehendo door overmacht niet
          aan haar verplichtingen jegens Opdrachtgever kan voldoen, worden die
          verplichtingen opgeschort voor de duur van de overmachtstoestand.
          Tevens heeft Reprehendo in geval van overmacht het recht om
          de&nbsp;&nbsp;Overeenkomst geheel of gedeeltelijk te ontbinden.
        </p>

        <p>
          9.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Onder overmacht van Reprehendo wordt
          verstaan elke van de wil van Reprehendo onafhankelijke omstandigheid,
          waardoor de nakoming van haar verplichtingen jegens Opdrachtgever
          geheel of gedeeltelijk wordt verhinderd of waardoor de nakoming van
          haar verplichtingen in redelijkheid niet van Reprehendo kan worden
          verlangd, ongeacht of die omstandigheid ten tijde van het sluiten van
          de Overeenkomst te voorzien was. Tot die omstandigheden worden ook
          gerekend: stakingen en uitsluitingen, stagnatie of andere problemen
          bij de productie van Reprehendo’s Toeleveranciers en/of bij het eigen
          of door derden verzorgde transport en/of maatregelen van enige
          overheidsinstantie.
        </p>

        <p>
          <strong>Artikel 10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Overig</strong>
        </p>

        <p>
          10.1&nbsp;&nbsp;&nbsp;Het is Reprehendo toegestaan de in de
          Overeenkomst met Opdrachtgever omschreven rechten en verplichtingen
          aan derden over te dragen.
        </p>

        <p>
          10.2&nbsp;&nbsp;&nbsp;&nbsp;Reprehendo is gerechtigd de overeengekomen
          tarieven op grond van een nadien opgetreden stijging van
          kostprijsfactoren te verhogen en direct aan Opdrachtgever in rekening
          te brengen.
        </p>

        <p>
          10.3&nbsp;&nbsp;&nbsp;&nbsp;Ingeval van overlijden van de
          Opdrachtgever, ingeval van fusie van de onderneming van Opdrachtgever
          met een derde, dan wel overgang van de onderneming van Opdrachtgever
          aan een derde, wordt de Overeenkomst, tenzij schriftelijk anders
          overeengekomen, voortgezet op naam en voor rekening van de
          rechtsopvolgers van Opdrachtgever.
        </p>

        <p>
          10.4&nbsp;&nbsp;&nbsp;&nbsp;In geval een of meer bepalingen van deze
          Algemene Voorwaarden niet-bindend, nietig of vernietigbaar zou blijken
          te zijn, dan zullen andere bepalingen van deze Algemene Voorwaarden in
          stand blijven. Partijen zullen in dergelijke gevallen onderhandelen om
          deze Algemene Voorwaarden zodanig aan te passen dat deze zoveel
          mogelijk in overeenstemming is met het onderwerp en doel van deze
          Algemene Voorwaarden.
        </p>

        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;10.5&nbsp;&nbsp; Indien n of meer bepalingen
          van deze Algemene Voorwaarden strijdig zijn met het bepaalde in de
          overeenkomst, prevaleren deze Algemene Voorwaarden.
        </p>

        <p>
          <strong>Artikel 11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Wijziging
            Algemene Voorwaarden</strong>
        </p>

        <p>
          11.1&nbsp;&nbsp;&nbsp;Reprehendo heeft het recht de Algemene
          Voorwaarden te wijzigen en de gewijzigde Algemene Voorwaarden op
          bestaande overeenkomsten van toepassing te verklaren.
        </p>

        <p>
          11.2&nbsp;&nbsp;&nbsp;Indien Reprehendo de gewijzigde Algemene
          Voorwaarden op bestaande overeenkomsten van toepassing verklaart, zal
          Reprehendo de wijzigingen tijdig bekend maken. Zij zullen in werking
          treden 30 dagen na schriftelijke bekendmaking van de wijzigingen of op
          een latere datum die in de bekendmaking is vermeld.
        </p>

        <p>
          11.3&nbsp;&nbsp;Indien de Opdrachtgever een wijziging in de Algemene
          Voorwaarden niet wenst te accepteren, kan hij de Overeenkomst tegen de
          datum waarop de gewijzigde voorwaarden van kracht worden, opzeggen.
          Voorwaarde is dat Opdrachtgever de opzegging zo spoedig mogelijk, doch
          uiterlijk binnen twee weken na de schriftelijke bekendmaking van de
          wijziging schriftelijk en aangetekend bij Reprehendo meldt.
        </p>

        <p>
          <strong>Artikel 12&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Geschillen en
            toepasselijk recht</strong>
        </p>

        <p>
          12.1&nbsp;&nbsp;&nbsp;&nbsp;Alle geschillen, welke mochten ontstaan
          naar aanleiding van deze Algemene Voorwaarden en/of de Overeenkomst
          tussen Reprehendo en Opdrachtgever, zullen uitsluitend worden beslecht
          door de bevoegde rechter te Amsterdam, tenzij Reprehendo en
          Opdrachtgever schriftelijk anders overeenkomen.
        </p>

        <p>
          12.2&nbsp;&nbsp;&nbsp;&nbsp;Op de Overeenkomst waarop deze Algemene
          Voorwaarden van toepassing zijn, alsmede alle offertes van Reprehendo
          is uitsluitend het Nederlandse recht van toepassing.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Demo",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Demo aanvragen",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.hero {
  padding: 100px 0 200px;
  min-height: 100vh;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
  position: relative;
  z-index: 1;
}
.zoho-form {
  background: $grey-light;
  border-radius: $border-radius;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
}
</style>
